const EditCampaign = () => import(/* webpackChunkName: "editCampaign" */ 'Features/campaign/Main');

export default {
  name: 'editCampaign',
  path: 'editCampaign/:campaignId',
  component: EditCampaign,
  meta: {
    requiresAuth: true,
    title: 'message.editCampaign',
    breadcrumb: 'message.editCampaign'
  }
}
